<div class="container create-request-from-composer-dialog">
  <div class="header">
    <div class="title">
      @if (!showCopyView) {
        <span [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_HEADLINE'"></span>
      }
      @if (showCopyView) {
        <span [fiTranslation]="'COMPOSER_LEAD_GENERATED_ID_HEADLINE'"></span>
      }
    </div>
    <fi-button
      variant="tertiary"
      tone="neutral"
      size="lg"
      [iconOnly]="true"
      class="close-btn"
      (click)="closeDialog()"
    >
      <mat-icon fiButtonIcon>close</mat-icon>
      <span fiTranslation="ALT_TEXT_DIALOG_CLOSE"></span>
    </fi-button>
  </div>

  @if (!showCopyView) {
    <div class="description"
    [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_GENERAL_TEXT'"></div>
  }
  @if (showCopyView) {
    <div class="description"
    [fiTranslation]="'COMPOSER_LEAD_GENERATED_ID_GENERAL_TEXT'"></div>
  }


  @if (!showCopyView) {
    <div class="guide-container">
      <div class="guide-headline" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_TEXT_HOW'"></div>
      <div class="guide-steps">
        <div class="guide-step">
          <div class="step-title" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP1_LABEL'"></div>
          <div class="step-text" [hasHTMLTags]="true"
          [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP1_DESCRIPTION'"></div>
          <div class="step-image">
            <div class="step-field">
              <span [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP1_BUTTON'"></span>
              <svg class="cursor-icon" xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19" fill="none">
                <path d="M7.25575 18.3267L3.775 10.8345L0 16.1057V0L12.5768 9.8845H6.0825L9.52875 17.2635L7.25575 18.3267Z" fill="black"/>
              </svg>
            </div>
          </div>
          <div class="step-bottom-text" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_CONTACTS_LABEL'"></div>
        </div>
        <div class="guide-step">
          <div class="step-title" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP2_LABEL'"></div>
          <div class="step-text" [hasHTMLTags]="true"
          [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP2_DESCRIPTION'"></div>
          <div class="step-image">
            <div class="copy-field-markup">
              <div class="label" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP2_INPUT_LABEL'"></div>
              <div class="copy-box">
                <div class="step-field">
                  <span [fiTranslation]="'20251228050'"></span>
                  <svg class="cursor-icon cursor-icon-on-copy" xmlns="http://www.w3.org/2000/svg" width="13" height="19" viewBox="0 0 13 19" fill="none">
                    <path d="M7.25575 18.3267L3.775 10.8345L0 16.1057V0L12.5768 9.8845H6.0825L9.52875 17.2635L7.25575 18.3267Z" fill="black"/>
                  </svg>
                </div>
                <div class="copy-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
                    <path
                      d="M5.13653 13.7838C4.64766 13.7838 4.23387 13.623 3.89516 13.3014C3.55645 12.9797 3.3871 12.5868 3.3871 12.1226V1.66118C3.3871 1.19697 3.55645 0.804054 3.89516 0.482432C4.23387 0.160811 4.64766 0 5.13653 0H13.2506C13.7394 0 14.1532 0.160811 14.4919 0.482432C14.8306 0.804054 15 1.19697 15 1.66118V12.1226C15 12.5868 14.8306 12.9797 14.4919 13.3014C14.1532 13.623 13.7394 13.7838 13.2506 13.7838H5.13653ZM5.13653 12.4054H13.2506C13.3251 12.4054 13.3933 12.3759 13.4552 12.317C13.5173 12.2581 13.5484 12.1934 13.5484 12.1226V1.66118C13.5484 1.59042 13.5173 1.52563 13.4552 1.46682C13.3933 1.40786 13.3251 1.37838 13.2506 1.37838H5.13653C5.06202 1.37838 4.99379 1.40786 4.93185 1.46682C4.86976 1.52563 4.83871 1.59042 4.83871 1.66118V12.1226C4.83871 12.1934 4.86976 12.2581 4.93185 12.317C4.99379 12.3759 5.06202 12.4054 5.13653 12.4054ZM1.74944 17C1.26056 17 0.846774 16.8392 0.508065 16.5176C0.169355 16.1959 0 15.803 0 15.3388V3.49901H1.45161V15.3388C1.45161 15.4096 1.48266 15.4744 1.54476 15.5332C1.60669 15.5921 1.67492 15.6216 1.74944 15.6216H11.3151V17H1.74944Z"
                      fill="currentColor"/>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="step-bottom-text" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_CONTACTS_LABEL'"></div>
        </div>
        <div class="guide-step">
          <div class="step-title" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP3_LABEL'"></div>
          <div class="step-text" [hasHTMLTags]="true"
          [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP3_DESCRIPTION'"></div>
          <div class="step-image">
            <div class="fields">
              <div class="box">
                <div class="label" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP3_INPUT_LABEL1'"></div>
                <div class="field" [fiTranslation]="'20251228050'"></div>
              </div>
              <div class="box">
                <div class="label" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP3_INPUT_LABEL2'"></div>
                <div class="field"></div>
              </div>
              <div class="box">
                <div class="label" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_STEP3_INPUT_LABEL3'"></div>
                <div class="field"></div>
              </div>
            </div>
          </div>
          <div class="step-bottom-text" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_COMPOSER_LABEL'"></div>
        </div>
      </div>
    </div>
  }

  @if (showCopyView) {
    <div class="result-box">
      <div class="result-box-field">
        <div class="label" [fiTranslation]="'COMPOSER_LEAD_GENERATED_ID_LABEL_ENQUIRY_ID'"></div>
        <div class="copy-box">
          <div class="result-box-value">{{copyCode}}</div>
          <div class="copy-icon" (click)="copyToClipboard(false)" #copy fiTranslation="COMPOSER_LEAD_GENERATED_ID_ALT_TEXT_COPY" [isTitle]="true" matTooltip="{{copy.dataset.matTooltip}}"
            matTooltipPosition="below" matTooltipClass='tooltip-style' >
            <svg xmlns="http://www.w3.org/2000/svg" width="15" height="17" viewBox="0 0 15 17" fill="none">
              <path
                d="M5.13653 13.7838C4.64766 13.7838 4.23387 13.623 3.89516 13.3014C3.55645 12.9797 3.3871 12.5868 3.3871 12.1226V1.66118C3.3871 1.19697 3.55645 0.804054 3.89516 0.482432C4.23387 0.160811 4.64766 0 5.13653 0H13.2506C13.7394 0 14.1532 0.160811 14.4919 0.482432C14.8306 0.804054 15 1.19697 15 1.66118V12.1226C15 12.5868 14.8306 12.9797 14.4919 13.3014C14.1532 13.623 13.7394 13.7838 13.2506 13.7838H5.13653ZM5.13653 12.4054H13.2506C13.3251 12.4054 13.3933 12.3759 13.4552 12.317C13.5173 12.2581 13.5484 12.1934 13.5484 12.1226V1.66118C13.5484 1.59042 13.5173 1.52563 13.4552 1.46682C13.3933 1.40786 13.3251 1.37838 13.2506 1.37838H5.13653C5.06202 1.37838 4.99379 1.40786 4.93185 1.46682C4.86976 1.52563 4.83871 1.59042 4.83871 1.66118V12.1226C4.83871 12.1934 4.86976 12.2581 4.93185 12.317C4.99379 12.3759 5.06202 12.4054 5.13653 12.4054ZM1.74944 17C1.26056 17 0.846774 16.8392 0.508065 16.5176C0.169355 16.1959 0 15.803 0 15.3388V3.49901H1.45161V15.3388C1.45161 15.4096 1.48266 15.4744 1.54476 15.5332C1.60669 15.5921 1.67492 15.6216 1.74944 15.6216H11.3151V17H1.74944Z"
                fill="currentColor"/>
            </svg>
          </div>
          @if (showSuccess) {
            <div class="success-text">
              <img src="assets/icons/check-green-filled.svg" alt="checkmark">
              <span [fiTranslation]="copySuccessMessage"></span>
            </div>
          }
        </div>
      </div>
    </div>
  }

  @if (!showCopyView) {
    <div class="button-row">
      <button class="cancel" (click)="closeDialog()">
        <span class="btn-title" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_BUTTON_CANCEL'"></span>
      </button>
      <button class="generate" (click)="generateId()" [disabled]="generateInProgress">
        @if (generateInProgress) {
          <mat-spinner class="loader" [diameter]="20"></mat-spinner>
        }
        <span class="btn-title" [fiTranslation]="'COMPOSER_LEAD_EXPLAINATION_BUTTON_GENERATE_ID'"></span>
      </button>
    </div>
  }

  @if (showCopyView) {
    <div class="button-row">
      <div class="button-row-link" [fiTranslation]="'COMPOSER_LEAD_GENERATED_ID_LINK_MANUAL'" [hasHTMLTags]="true"></div>
      <button class="cancel" (click)="closeDialog()">
        <span class="btn-title" [fiTranslation]="'COMPOSER_LEAD_GENERATED_ID_BUTTON_CLOSE'"></span>
      </button>
      @if (!hideCopyButton) {
        <button class="generate" (click)="copyToClipboard(true)">
          <span class="btn-title" [fiTranslation]="'COMPOSER_LEAD_GENERATED_ID_BUTTON_COPY_ID'"></span>
        </button>
      }
    </div>
  }

</div>

